// libs import
import Vue from 'vue';
import VueRouter from 'vue-router';
import vClickOutside from 'v-click-outside';
import Moment from 'vue-moment';
import Chartist from 'chartist';
import VeeValidate from 'vee-validate';
import VueInstant from 'vue-instant';
import VueStomp from "./plugins/vue-stopm";
import 'vue2-timepicker/dist/VueTimepicker.css'
import Toasted from 'vue-toasted';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;
// or you can use it with require
// var Toasted = require('vue-toasted').default



// plugins import
import SessionService from "./services/session";
import SideBar from './components/Shared/SidebarPlugin';
import WebsocketConfiguration from './websocketConfiguration'
import SharedComponents from './sharedComponents';
import App from './App';

// routes
import routes from './routes/routes';


// packages import
import 'bootstrap/dist/css/bootstrap.css';
import 'sweetalert2/dist/sweetalert2.css';
import 'vue-instant/dist/vue-instant.css';
import 'es6-promise/auto';
import 'vue2-loading-bar';
import * as VueGoogleMaps from "vue2-google-maps" // Import package
import vueTabevents from 'vue-tabevents';
import Autocomplete from 'vuejs-auto-complete'
import VueTimepicker from 'vue2-timepicker'

// styles inject
import './assets/sass/app.scss';
import Users from "./components/Users/Users";
import AddUser from "./components/Users/Add/AddUser";
import EditUser from "./components/Users/Edit/EditUser";
import UserPayment from "./components/Users/Payment/UserPayment";
import AddPayment from "./components/Users/Payment/Add/AddPayment";
import Profile from "./components/Users/Profile/Profile";
import Term from "./components/Term/Term";
import AddTerm from "./components/Term/Add/AddTerm";
import EditTerm from "./components/Term/Edit/EditTerm";

import EditPayment from "./components/Users/Payment/Edit/EditPayment";
import Rules from "./components/Account/Rules";
import ResetPassword from "./components/Account/ResetPassword";

// plugin setup
Vue.use(VueRouter);
Vue.use(vClickOutside);
Vue.use(SideBar);
Vue.use(VeeValidate);
Vue.use(Moment);
Vue.use(VueInstant);
Vue.use(SharedComponents)
Vue.use(VueStomp);
Vue.use(Users);
Vue.use(AddUser);
Vue.use(EditUser);
Vue.use(UserPayment);
Vue.use(AddPayment);
Vue.use(Profile);
Vue.use(Term);
Vue.use(AddTerm);
Vue.use(EditTerm);
Vue.use(EditPayment);
Vue.use(Rules);
Vue.use(ResetPassword);
Vue.use(VueTimepicker);
Vue.use(Toasted);
Vue.use(pdfMake);
Vue.use(pdfFonts);
Vue.use(VueGoogleMaps, {
    load: {
        // key: "AIzaSyDKlZazRBCWvmFg7tBsEIfzsOA_YVtdKZQ"
        key: "AIzaSyDFUs-RtGL2xXI_FPyWe-gJvw30F3GuU28"

    }
});
Vue.use(vueTabevents);


// configure router
const router = new VueRouter({
    routes, // short for routes: routes
    linkActiveClass: 'active'
});

export const EventBus = new Vue();
export const TopNavbar = new Vue();
export const Loader = new Vue();

Vue.prototype.$eventBus = EventBus;
Vue.prototype.$topnavbar = TopNavbar;
Vue.prototype.$loader = Loader;


SessionService.init(router);
Vue.prototype.$sessionService = SessionService;

EventBus.$on('print-something', function () {
    console.log('something');
});

// global library setup
Object.defineProperty(Vue.prototype, '$Chartist', {
    get() {
        return this.$root.Chartist
    }
});

/* eslint-disable no-new */
new Vue({
    el: '#app',
    render: h => h(App),
    router,
    mounted() {
        //new WebsocketConfiguration(this, "http://localhost:8080/pushnotifications");
    },
    stompClient:{
        monitorIntervalTime: 100,
        stompReconnect: true
    }
})



// WEBPACK FOOTER //
// ./src/main.js